



















































// Utilities
import { waitForReadystate } from '@/utils/componentHelpers';
import accounts from '@/mixins/accounts';
import mixins from '@/utils/mixins';

import '@/styles/overrides.sass';

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';

import { IMaintenance } from '@/models';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default mixins(accounts).extend({
  metaInfo: {
    titleTemplate: '%s Jamesway',
    htmlAttrs: {
      lang: 'en'
    }
  },
  name: 'App',

  components: { ErrorAlert },

  data: () => ({
    loading: false,
    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    ...mapGetters({
      getNearestMaintenance: 'maintenance/getNearestMaintenance',
      lightCompanyImage: 'app/lightCompanyImage'
    }),

    maintenance(): IMaintenance | undefined {
      return this.getNearestMaintenance;
    },

    isCurrrentlyUnderMaintenance(): boolean {
      if (!this.maintenance) {
        return false;
      }
      return this.maintenance.isUnderMaintenance;
    }
  },

  methods: {
    ...mapActions({
      fetchMaintenances: 'maintenance/fetchMaintenances'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    }
  },

  async mounted() {
    const startDate = moment(Date.now())
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');
    const endDate = moment(Date.now())
      .utc()
      .add(1, 'weeks')
      .format('YYYY-MM-DDTHH:mm:ss');

    this.loading = true;
    this.fetchMaintenances({
      start: startDate,
      end: endDate
    })
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
        if (error.response.data.detail) {
          this.detailErrorMessage = error.response.data.detail;
        }
      })
      .finally(() => {
        this.loading = false;
      });
    if (!this.$route.hash) return;

    await this.$nextTick();
    await waitForReadystate();

    this.$vuetify.goTo(this.$route.hash);
  }
});
